<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">产品方案渠道控制</p>
      <div class="content-input">
        <div class="content-input-item">
          <ChannelPackageList :packageName="packageName" :channel="channel" @getChange="getChannelPackage" :reload="reload"/>
        </div>
        <div class="content-input-item">
          <label>注册第二步：</label>
          <el-select v-model="regSecondStep" placeholder="Select" style="width: 8em">
            <el-option v-for="item in regSecondStepArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>注册第三步-男-提交：</label>
          <el-select v-model="regThirdSubMale" placeholder="Select" style="width: 8em">
            <el-option v-for="item in regThirdSubMaleArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>注册第三步-女-提交：</label>
          <el-select v-model="regThirdSubFemale" placeholder="Select" style="width: 8em">
            <el-option v-for="item in regThirdSubFemaleArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>注册第三步-男-跳过：</label>
          <el-select v-model="regThirdSkipMale" placeholder="Select" style="width: 8em">
            <el-option v-for="item in regThirdSkipMaleArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>注册第三步-女-跳过：</label>
          <el-select v-model="regThirdSkipFemale" placeholder="Select" style="width: 8em">
            <el-option v-for="item in regThirdSkipFemaleArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>校验认证状态-男：</label>
          <el-select v-model="checkAuthMale" placeholder="Select" style="width: 8em">
            <el-option v-for="item in checkAuthMaleArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>校验认证状态-女：</label>
          <el-select v-model="checkAuthFemale" placeholder="Select" style="width: 8em">
            <el-option v-for="item in checkAuthFemaleArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="content-input-item">-->
<!--          <DatePickerRange title="上传时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>-->
<!--        </div>-->
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchTypeList="searchTypeList" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />-->
<!--          &lt;!&ndash;          <el-checkbox style="margin-left: 8px;" v-model="limitState">限制</el-checkbox>&ndash;&gt;-->
<!--        </div>-->
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="batchUpdate(1)">注册第二步</el-button>
          <el-button type="primary" @click="batchUpdate(2)">注册第三步-提交按钮</el-button>
          <el-button type="primary" @click="batchUpdate(3)">注册第三步-跳过按钮</el-button>
          <el-button type="primary" @click="batchUpdate(4)">是否校验认证状态</el-button>
<!--          <el-button type="success" @click="syncChannel" v-loading="syncLoading">同步最新的渠道</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="channel" label="渠道" v-if="checkColList.indexOf('渠道') > -1" />
          <el-table-column property="packageName" label="包名" v-if="checkColList.indexOf('包名') > -1" />
          <el-table-column property="" label="注册第二步" v-if="checkColList.indexOf('注册第二步') > -1">
            <template #default="scope">
              <span>{{scope.row.regSecondStep==1?'直接进入':scope.row.regSecondStep==2?'跳到第三步':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="注册第三步" v-if="checkColList.indexOf('注册第三步') > -1" align="center">
            <el-table-column property="" label="男-提交按钮">
              <template #default="scope">
                <span>{{scope.row.regThirdSubMale==1?'直接进入':scope.row.regThirdSubMale==2?'付费后进入':''}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="女-提交按钮">
              <template #default="scope">
                <span>{{scope.row.regThirdSubFemale==1?'直接进入':scope.row.regThirdSubFemale==2?'付费后进入':''}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="男-跳过按钮">
              <template #default="scope">
                <span>{{scope.row.regThirdSkipMale==1?'直接进入':scope.row.regThirdSkipMale==2?'付费后进入':scope.row.regThirdSkipMale==3?'人脸识别后进入':scope.row.regThirdSkipMale==4?'邀请码进入':''}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="女-跳过按钮">
              <template #default="scope">
                <span>{{scope.row.regThirdSkipFemale==1?'直接进入':scope.row.regThirdSkipFemale==2?'付费后进入':scope.row.regThirdSkipFemale==3?'人脸识别后进入':scope.row.regThirdSkipFemale==4?'邀请码进入':''}}</span>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column property="" label="判VIP前是否校验认证状态" v-if="checkColList.indexOf('判VIP前是否校验认证状态') > -1" align="center">
            <el-table-column property="" label="男">
              <template #default="scope">
                <span>{{scope.row.checkAuthMale==0?'不校验':scope.row.checkAuthMale==1?'校验':''}}</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="女">
              <template #default="scope">
                <span>{{scope.row.checkAuthFemale==0?'不校验':scope.row.checkAuthFemale==1?'校验':''}}</span>
              </template>
            </el-table-column>
          </el-table-column>

<!--          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">-->
<!--            <template #default="scope">-->
<!--              <UserLog :user-log-list="scope.row.userLogList" />-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getChannelPowerConfigPageList, syncChannelPowerConfig} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
// import UserLogDialog from '../../components/UserLog/UserLogDialog'
// import ImgViewer from '../../assets/js/imageViewer'
// import UserLog from "@/components/UserLog/UserLog";
import ChannelPackageList from "@/components/resume/ChannelPackageList_c";
import channelControlDialog from "@/views/channel/components/channelControlDialog";
// import UploadOrderDialog from "@/views/data/components/UploadOrderDialog";

export default {
  name: "ChannelControl",
  components: { ChannelPackageList },
  data() {
    return {

      limitState: false,

      //渠道、包名
      packageName: 0,
      channel: 0,
      reload: false,

      // 第一步
      // regFirstStepArray: [
      //   {label: '不限', value: -1},
      //   {label: '直接进入', value: 1},
      //   {label: '跳到第二步', value: 2},
      // ],
      // regFirstStep: -1,

      // 第二步
      regSecondStepArray: [
        {label: '不限', value: -1},
        {label: '直接进入', value: 1},
        {label: '跳到第三步', value: 2},
      ],
      regSecondStep: -1,


      // 第三步-男-提交
      regThirdSubMaleArray: [
        {label: '不限', value: -1},
        {label: '直接进入', value: 1},
        {label: '付费后进入', value: 2},
      ],
      regThirdSubMale: -1,

      // 第三步-女-提交
      regThirdSubFemaleArray: [
        {label: '不限', value: -1},
        {label: '直接进入', value: 1},
        {label: '付费后进入', value: 2},
      ],
      regThirdSubFemale: -1,

      // 第三步-男-跳过
      regThirdSkipMaleArray: [
        {label: '不限', value: -1},
        {label: '直接进入', value: 1},
        {label: '付费后进入', value: 2},
        {label: '人脸识别后进入', value: 3},
        {label: '邀请码进入', value: 4},
      ],
      regThirdSkipMale: -1,

      // 第三步-女-跳过
      regThirdSkipFemaleArray: [
        {label: '不限', value: -1},
        {label: '直接进入', value: 1},
        {label: '付费后进入', value: 2},
        {label: '人脸识别后进入', value: 3},
        {label: '邀请码进入', value: 4},
      ],
      regThirdSkipFemale: -1,


      // 校验认证状态-男
      checkAuthMaleArray: [
        {label: '不限', value: -1},
        {label: '不校验', value: 0},
        {label: '校验', value: 1},
      ],
      checkAuthMale: -1,

      // 校验认证状态-女
      checkAuthFemaleArray: [
        {label: '不限', value: -1},
        {label: '不校验', value: 0},
        {label: '校验', value: 1},
      ],
      checkAuthFemale: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['渠道', '包名', '注册第二步', '注册第三步', '判VIP前是否校验认证状态'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '付款ID', value : 4},
        {label : '付款账户', value : 5},
      ],

      idArray: [],
      syncLoading: false,

    }
  },
  methods: {

    //渠道包名
    getChannelPackage(val) {
      // console.log(val)
      this.packageName = val[0];
      this.channel = val[1];
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      // this.isChecked = true;
      this.regSecondStep = -1;
      this.regThirdSubMale = -1;
      this.regThirdSubFemale = -1;
      this.regThirdSkipMale = -1;
      this.regThirdSkipFemale = -1;
      this.checkAuthMale = -1;
      this.checkAuthFemale = -1;
      // this.searchValue = '';
      this.channel = 0;
      this.packageName = 0;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
      // console.log(this.idArray)
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          // this.getSummarydata();
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['regSecondStep'] = this.regSecondStep;
      param['regThirdSubMale'] = this.regThirdSubMale;
      param['regThirdSubFemale'] = this.regThirdSubFemale;
      param['regThirdSkipMale'] = this.regThirdSkipMale;
      param['regThirdSkipFemale'] = this.regThirdSkipFemale;
      param['checkAuthMale'] = this.checkAuthMale;
      param['checkAuthFemale'] = this.checkAuthFemale;
      param['packageNameId'] = this.packageName;
      param['channelId'] = this.channel;
      // param['startTime'] = this.startTime;
      // param['endTime'] = this.endTime;
      // param['searchType'] = this.searchType;
      // param['searchValue'] = this.searchValue;
      // param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getChannelPowerConfigPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      // if(column.label == '用户日志') {
      //   Dialog.open({
      //     title: '用户日志',
      //     component: UserLogDialog,
      //     data: {
      //       id: row.userId
      //     },
      //     close: () => {
      //       row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
      //     }
      //   })
      // }


    },

    batchUpdate(type) {
      if(this.idArray.length > 0) {
        Dialog.open({
          title: type==1?'当用户在注册第二步点击“确定”后':type==2?'当用户在注册第三步点击“提交证件”按钮后':type==3?'当用户在注册第三步点击“跳过”按钮后':type==4?'当用户APP内某些地方，判VIP前是否要校验认证状态': '',
          component: channelControlDialog,
          data: {
            idArray: this.idArray,
            type: type,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    //同步最新渠道
    syncChannel() {
      let _this = this
      _this.syncLoading = true
      postFormData(syncChannelPowerConfig).then(function (data) {
        let {msg, code} = data;
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          _this.getPage(true);
          _this.reload = !_this.reload
        }else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        _this.syncLoading = false
      })
          .catch(function (response) {
            _this.syncLoading = false
          })
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage(true);
  }
}
</script>

<style scoped>

</style>
